const Menu = [
  {
    title: 'Home',
    group: 'apps',
    icon: 'fa-home',
    name: 'Dashboard',
  },
  {
    title: 'Romaneios',
    group: 'apps',
    icon: 'icon-report',
    name: 'RomaneioIndex',
  },
  {
    title: 'Abate ao Vivo',
    group: 'apps',
    icon: 'fa-video',
    name: 'AbateOnline',
    requiredPlugin: 'abate_online',
  },
  {
    title: 'Permitir Acesso',
    group: 'apps',
    icon: 'fas fa-user-cog',
    name: 'ExplorerAccess',
  },
  {
    title: 'Propriedades',
    group: 'apps',
    icon: 'icon-farm',
    name: 'PropertyIndex',
  },
  {
    title: 'Produtores',
    group: 'apps',
    icon: 'icon-farmer',
    name: 'Explorer',
  },
  {
    title: 'Feedback',
    group: 'apps',
    icon: 'fa-comment-alt',
    name: 'Feedback',
  },
  {
    title: 'Manual do usuário',
    group: 'apps',
    icon: 'fa-life-ring',
    name: 'Help',
    target: '_blank',
  },
];
// reorder menu
Menu.forEach((item) => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase();
      let textB = y.title.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
  }
});

export default Menu;
